import { render, staticRenderFns } from "./RcvRL2.vue?vue&type=template&id=065a5f14"
import script from "./RcvRL2.vue?vue&type=script&lang=js"
export * from "./RcvRL2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports